// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-brand img {
  height: 70px;

}

.navbar {
  background-color: #fff;
  border-bottom: 1px solid #ddd;

}
 
.navbar .nav-link {
  color: #000;
  font-size: 1rem;
}
 
.services-mega-menu {
  left: 0;
  right: 0;
  top: 100%;
  position: absolute;
  background-color: #fff;
  border-top: 1px solid #ddd;
  z-index: 1050;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
 
/* Middle section list items background */
.list-unstyled li {
 
  padding: 0.75rem 1rem;
  border-radius: 20px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #006412;
  transition: background-color 0.3s;
}
 
.list-unstyled li:hover {
  color: aqua;
  border: 1px solid gray;
}
 
/* Heading border */
.menus-heading {
  /* border-bottom: 1px solid #d4d7d4; */
  display: inline-block;
  padding-bottom: 5px;
   margin-left: 100px; 
  /* margin-top: 30px; */
  margin-bottom: 15px;
  color: #006412;
  font-size: 30px;
}
 
/* Right section items */
.action-panel .action-item {
  background-color: #f5f7fa;
  padding: 0.75rem 1rem;
  font-weight: 500;
  color: #006412;
  border-radius: 10px;
  margin-bottom: 8px;
 
  transition: background-color 0.3s;
}
 
.action-panel .action-item:hover {
  background-color: #ffffff;
  text-decoration: none;
  border: 1px solid gray;
}
.action-panel .action-item {
  background-color: #f7fdfc;
  text-decoration: none;
   font-size: 17px;
}
 
/* Middle section list items */
.middle-item {
  /* background-color: #e6f4ea; */
  padding: 0.75rem 1rem;
  border-radius: 20px;
  margin-bottom: 8px;
  display: flex;
  font-size: 17px;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.3s;
}
 
/* Make text green inside <a> */
.middle-item a {
  color: #242524;
  font-weight: 500;
}
 
/* Hover effect */
.middle-item:hover {
  /* background-color: #d0ebd8; */
 
  font-weight: bold;
}
 
/* Existing heading and right panel styles stay the same */
/* Mobile View Adjustments */
@media (max-width: 992px) {
  .services-mega-menu {
    position: static;
    box-shadow: none;
    border-top: none;
    padding-top: 0;
  }
 
  .menus-heading {
    margin-left: 0;
    margin-bottom: 10px;
  }
 
  .middle-item,
  .action-panel .action-item {
    padding: 0.5rem 0.75rem;
    font-size: 1.2rem;
  }
 
  .navbar-nav .nav-link {
    font-size: 1rem;
    padding: 0.5rem 1rem;
  }
 
  .navbar-nav {
    gap: 0;
  }
 
  .action-panel {
    margin-top: 10px;
  }
}
 
 
 
.navbar {
  background-color: #fff;
  border-bottom: 1px solid #ddd;
}
 
.services-mega-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #fff;
  border-top: 1px solid #ddd;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1050;
}
 
@media (max-width: 992px) {
  .services-mega-menu {
    display: none;
  }
  .mobile-submenu {
    background-color: #f8f9fa;
    border-left: 3px solid #198754;
    margin: 0.5rem 1rem;
    border-radius: 10px;
    padding: 0.5rem 1rem;
  }
}

 
 
 
 
 .nav-link {
  position: relative;
  font-weight: 500;
}

.nav-link.active-link {
  color: #278329 !important;
}

.nav-link.active-link::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -6px;
  width: 100%;
  height: 3px;
  background: #278329;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;;AAEd;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;;AAE/B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;EACb,yCAAyC;AAC3C;;AAEA,yCAAyC;AACzC;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;GAClB,kBAAkB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;;EAElB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,qBAAqB;GACpB,eAAe;AAClB;;AAEA,8BAA8B;AAC9B;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,+BAA+B;;EAE/B,iBAAiB;AACnB;;AAEA,0DAA0D;AAC1D,4BAA4B;AAC5B;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;;IAEE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,MAAM;EACR;;EAEA;IACE,gBAAgB;EAClB;AACF;;;;AAIA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,0BAA0B;EAC1B,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;;;;;CAMC;EACC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".navbar-brand img {\r\n  height: 70px;\r\n\r\n}\r\n\r\n.navbar {\r\n  background-color: #fff;\r\n  border-bottom: 1px solid #ddd;\r\n\r\n}\r\n \r\n.navbar .nav-link {\r\n  color: #000;\r\n  font-size: 1rem;\r\n}\r\n \r\n.services-mega-menu {\r\n  left: 0;\r\n  right: 0;\r\n  top: 100%;\r\n  position: absolute;\r\n  background-color: #fff;\r\n  border-top: 1px solid #ddd;\r\n  z-index: 1050;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n}\r\n \r\n/* Middle section list items background */\r\n.list-unstyled li {\r\n \r\n  padding: 0.75rem 1rem;\r\n  border-radius: 20px;\r\n  margin-bottom: 8px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  color: #006412;\r\n  transition: background-color 0.3s;\r\n}\r\n \r\n.list-unstyled li:hover {\r\n  color: aqua;\r\n  border: 1px solid gray;\r\n}\r\n \r\n/* Heading border */\r\n.menus-heading {\r\n  /* border-bottom: 1px solid #d4d7d4; */\r\n  display: inline-block;\r\n  padding-bottom: 5px;\r\n   margin-left: 100px; \r\n  /* margin-top: 30px; */\r\n  margin-bottom: 15px;\r\n  color: #006412;\r\n  font-size: 30px;\r\n}\r\n \r\n/* Right section items */\r\n.action-panel .action-item {\r\n  background-color: #f5f7fa;\r\n  padding: 0.75rem 1rem;\r\n  font-weight: 500;\r\n  color: #006412;\r\n  border-radius: 10px;\r\n  margin-bottom: 8px;\r\n \r\n  transition: background-color 0.3s;\r\n}\r\n \r\n.action-panel .action-item:hover {\r\n  background-color: #ffffff;\r\n  text-decoration: none;\r\n  border: 1px solid gray;\r\n}\r\n.action-panel .action-item {\r\n  background-color: #f7fdfc;\r\n  text-decoration: none;\r\n   font-size: 17px;\r\n}\r\n \r\n/* Middle section list items */\r\n.middle-item {\r\n  /* background-color: #e6f4ea; */\r\n  padding: 0.75rem 1rem;\r\n  border-radius: 20px;\r\n  margin-bottom: 8px;\r\n  display: flex;\r\n  font-size: 17px;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  transition: background-color 0.3s;\r\n}\r\n \r\n/* Make text green inside <a> */\r\n.middle-item a {\r\n  color: #242524;\r\n  font-weight: 500;\r\n}\r\n \r\n/* Hover effect */\r\n.middle-item:hover {\r\n  /* background-color: #d0ebd8; */\r\n \r\n  font-weight: bold;\r\n}\r\n \r\n/* Existing heading and right panel styles stay the same */\r\n/* Mobile View Adjustments */\r\n@media (max-width: 992px) {\r\n  .services-mega-menu {\r\n    position: static;\r\n    box-shadow: none;\r\n    border-top: none;\r\n    padding-top: 0;\r\n  }\r\n \r\n  .menus-heading {\r\n    margin-left: 0;\r\n    margin-bottom: 10px;\r\n  }\r\n \r\n  .middle-item,\r\n  .action-panel .action-item {\r\n    padding: 0.5rem 0.75rem;\r\n    font-size: 1.2rem;\r\n  }\r\n \r\n  .navbar-nav .nav-link {\r\n    font-size: 1rem;\r\n    padding: 0.5rem 1rem;\r\n  }\r\n \r\n  .navbar-nav {\r\n    gap: 0;\r\n  }\r\n \r\n  .action-panel {\r\n    margin-top: 10px;\r\n  }\r\n}\r\n \r\n \r\n \r\n.navbar {\r\n  background-color: #fff;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n \r\n.services-mega-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  background-color: #fff;\r\n  border-top: 1px solid #ddd;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  z-index: 1050;\r\n}\r\n \r\n@media (max-width: 992px) {\r\n  .services-mega-menu {\r\n    display: none;\r\n  }\r\n  .mobile-submenu {\r\n    background-color: #f8f9fa;\r\n    border-left: 3px solid #198754;\r\n    margin: 0.5rem 1rem;\r\n    border-radius: 10px;\r\n    padding: 0.5rem 1rem;\r\n  }\r\n}\r\n\r\n \r\n \r\n \r\n \r\n .nav-link {\r\n  position: relative;\r\n  font-weight: 500;\r\n}\r\n\r\n.nav-link.active-link {\r\n  color: #278329 !important;\r\n}\r\n\r\n.nav-link.active-link::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  bottom: -6px;\r\n  width: 100%;\r\n  height: 3px;\r\n  background: #278329;\r\n  border-radius: 3px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
